module.exports = __webpack_public_path__ + "img/arrow-up-right-from-square.43cdf20d.svg";